import { MicroHeader } from "features/shared/styles/typography/MicroHeader.styled";
import ChecklistResolutionStatus from "models/checklist/checklist-resolution-status";
import styled from "styled-components";

interface PaxActionProps {
  status: ChecklistResolutionStatus;
}

const PaxAction = styled(MicroHeader)<PaxActionProps>`
  color: ${({ status, theme }) => {
    switch (status) {
      case ChecklistResolutionStatus.ActionRequired:
        return theme.colors.primary1;
      default:
        return theme.colors.base5;
    }
  }};

  @media all and (max-width: ${({ theme }) => theme.mobileBreakingPoint}) {
    display: none;
  }
`;

export default PaxAction;
